<script>
    import { getContext, setContext } from 'svelte';
    import { writable } from 'svelte/store';
    import { scaleUtc } from 'd3-scale';

    import TimelineTooltip from './timeline/TimelineTooltip.svelte';
    import TimelineHeader from './timeline/TimelineHeader.svelte';
    import TimelineDays from './timeline/TimelineDays.svelte';
    import TimelineRow from './timeline/TimelineRow.svelte';

    export let dataKey;

    // --- Data and layout
    const {
        selector,
        time_range,
        moving_time,
        stops,
        car,
        enable_timeline,
        trajectory,
        geo_distance,
    } = getContext(dataKey);
    const layout = {
        width: 800,
        height: 30,
        headerHeight: 25,
        zoomSpeed: 0.005,
        zoomLowerBoud: 0.01,
        zoomUpperBoud: 1,
        margin: {
            left: 10,
            right: 10,
            top: 4,
            bottom: 5,
        },
    };

    const width = layout.width + layout.margin.right + layout.margin.left;
    const height =
        layout.height +
        layout.headerHeight +
        layout.margin.bottom +
        layout.margin.top;

    // --- Time scale
    const _timeScale = scaleUtc().range([layout.margin.left, layout.width]);
    const timeScale = (t, _) => _timeScale(new Date(t));
    timeScale.invert = _timeScale.invert;

    // --- Tooltip
    const tooltip = writable();

    // --- Set context
    let timelineKey = {};
    setContext(timelineKey, {
        tooltip,
        time_range,
        timeScale,
        selector,
        stops,
        car,
        h: layout.height,
        trajectory,
        geo_distance,
    });

    let headerKey = {};
    setContext(headerKey, {
        w: layout.width,
        width,
        time_range,
        moving_time,
        timeScale: _timeScale,
    });
</script>

<TimelineTooltip bind:handles={$tooltip} />

<div class="col card">
    <TimelineHeader {headerKey} {layout} />
    <div id="body">
        <svg
            {width}
            {height}
            on:dblclick={navigator.reset}
            on:click={(e) => selector.reset(e, '.stoprect')}
        >
            <g
                transform={`translate(0, ${
                    layout.headerHeight + layout.margin.top
                })`}
            >
                <TimelineDays {timeScale} {time_range} height={layout.height} />
                {#if $enable_timeline}
                    <TimelineRow {timelineKey} />
                {/if}
            </g>
        </svg>
    </div>
</div>
